import type { GaVueComponent } from "@/common/vueUtils";
import type { DeepReadonly } from "vue";
import type { Store } from "@/common/storeUtils";
import { GaFormFieldLabel } from "@/components/form/GaFormField";

type Props = {
  value: string;
  onUpdateValue: (newValue: string) => void;
  label?: string;
  name: string;
  placeholder?: string;
  rows?: number;
  help?: string;
  errors?: DeepReadonly<string[]>;
  disabled?: boolean;
};

export function GaFormFieldTextArea(props: Props): GaVueComponent {
  const errors = props.errors ?? [];

  return (
    <>
      {props.label !== undefined && props.label.trim().length > 0 ? (
        <label for={props.name} class="form-label">
          {props.label}
        </label>
      ) : null}
      <textarea
        disabled={props.disabled}
        class={{
          "form-control": true,
          "is-invalid": errors.length > 0,
        }}
        id={props.name}
        rows={props.rows}
        name={props.name}
        placeholder={props.placeholder}
        value={props.value}
        onInput={(e) => props.onUpdateValue((e.target as HTMLInputElement).value)}
      />
      {errors.map((error) => (
        <div class="invalid-feedback">{error}</div>
      ))}
      {props.help !== undefined && props.help.trim().length > 0 ? <div class="form-text">{props.help}</div> : null}
    </>
  );
}

export function GaFormFieldTextAreaExperimental(props: {
  store: Store<string>;
  name: string;
  onFocus?: () => void;
  onBlur?: () => void;
  label?: string | GaVueComponent;
  help?: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  errors?: DeepReadonly<string[]>;
  rows?: number;
}): GaVueComponent {
  const errors = props.errors ?? [];

  return (
    <div>
      <GaFormFieldLabel name={props.name} label={props.label} required={props.required} />
      <textarea
        disabled={props.disabled}
        class={{
          "form-control": true,
          "is-invalid": errors.length > 0,
        }}
        rows={props.rows}
        name={props.name}
        placeholder={props.placeholder}
        value={props.store.get()}
        onInput={(e) => props.store.set((e.target as HTMLInputElement).value)}
        onBlur={props.onBlur}
      />
      {errors.map((error) => (
        <div class="invalid-feedback">{error}</div>
      ))}
      {props.help !== undefined && props.help.trim().length > 0 ? <div class="form-text">{props.help}</div> : null}
    </div>
  );
}
